import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import "./AadharToPan.css";

export default function AadharToPan() {

  const user = JSON.parse(localStorage.getItem("user"));

  const [aadhar, setAadhar] = useState("");
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  // ================= FETCH HISTORY ALWAYS =================
  const fetchHistory = async () => {
    try {
      const res = await fetch(
        `https://rcfinder.online/api/get_aadhar_pan_history.php?user_id=${user.id}`
      );

      const data = await res.json();
      if (data.status === "success") {
        setHistory(data.list);
      }

    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    fetchHistory();
  }, []);

  // ================= SEARCH =================
  const searchPan = async () => {

    if (!aadhar || aadhar.length !== 12) {
      Swal.fire("Enter 12 Digit Aadhaar");
      return;
    }

    if (user.wallet_balance < 50) {
      Swal.fire("Low Balance", "Minimum ₹50 required", "warning");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch("https://rcfinder.online/api/aadhar_to_pan.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user_id: user.id,
          aadhar
        })
      });

      const data = await res.json();
      console.log(data);

      if (data.status === "wallet_low") {
        Swal.fire("Wallet Low", "Recharge First", "warning");
      }
      else if (data.status === "failed") {
        Swal.fire("Failed", data.message || "Not Found", "error");
      }
      else if (data.status === "success") {

        await Swal.fire({
          icon: "success",
          title: "PAN Found",
          html: `
            Aadhaar: <b>${data.aadhar}</b><br>
            PAN: <b>${data.pan}</b><br>
            Time: ${data.time}
          `,
          confirmButtonText: "OK"
        });

        // refresh list
        fetchHistory();
      }

    } catch(e){
      Swal.fire("Server Error");
    }

    setLoading(false);
  };


  return (
    <div className="pan-wrapper">

      <h2>Aadhaar → PAN Finder</h2>

      <div className="pan-box">

        <input
          type="number"
          placeholder="Enter Aadhaar Number"
          value={aadhar}
          onChange={e => setAadhar(e.target.value)}
        />

        <button onClick={searchPan}>
          {loading ? "Please wait..." : "Get PAN (₹50)"}
        </button>

      </div>

      {/* ================= HISTORY ================= */}
      <div className="pan-history">

        <h3>Search History</h3>

        {history.length === 0 ? (
          <p>No history yet</p>
        ) : (
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>Aadhaar</th>
                <th>PAN</th>
                <th>Date</th>
              </tr>
            </thead>

            <tbody>
              {history.map((h, i) => (
                <tr key={h.id}>
                  <td>{i + 1}</td>
                  <td>{h.aadhar}</td>
                  <td><b>{h.pan}</b></td>
                  <td>{h.created_at}</td>
                </tr>
              ))}
            </tbody>

          </table>
        )}

      </div>

    </div>
  );
}
